export default __webpack_public_path__ + "static/media/devil2.b76de6d4.jpg";